import axios from "../utils/axios";

const login = (email, password) => {
    return axios.post('login', { email, password });
}
const loginByAuthCode = (authCode) => {
    return axios.post('login', { authCode });
}

const changePassword = (userId, data) => {
    return axios.put(`user/${userId}/password`, data);
}

const sentResetPasswordEmail = (email) => {
    return axios.post(`reset-password-email`, { email });
}

const resetPassword = (data) => {
    return axios.post(`reset-password`, data);
}

const authService = {
    login,
    loginByAuthCode,
    changePassword,
    sentResetPasswordEmail,
    resetPassword,
}

export default authService;